import React, { FC } from 'react';
import { Button, VStack } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers';
import { HookFormInput } from '@olo-web/components/molecules/HookFormInput/HookFormInput.ui';
import { commonValidationSchema } from '@olo-web/utils/common/validationSchema';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useToast } from '@olo-web/utils/common/hooks';

type TFormValues = {
  email: string;
};

type TProps = {
  emails: string[];
  onSubmit: (email: string) => void;
};

export const EmailForm: FC<TProps> = ({ onSubmit, emails }) => {
  const { notify } = useToast();

  const { errors, handleSubmit, register, reset } = useForm<TFormValues>({
    resolver: yupResolver(
      yup.object().shape({
        email: commonValidationSchema.email,
      })
    ),
  });

  const addEmail = (data: TFormValues) => {
    if (emails.includes(data.email)) {
      notify({
        status: 'error',
        variant: 'left-accent',
        description: 'This emails is already added',
      });
      return;
    }
    onSubmit(data.email);
    reset({ email: '' });
  };

  return (
    <form onSubmit={handleSubmit(addEmail)} style={{ width: '100%' }}>
      <VStack>
        <HookFormInput ref={register} name="email" errors={errors} placeholder="new@admin.user" />
        <Button variant="ghost" type="submit">
          Get user by email
        </Button>
      </VStack>
    </form>
  );
};
